<template>
    <div class="marketing-leads-award-button">
        <div
            class="button"
            :class="{ 'is-disabled': disabled}"
            :style="btnStyle"
            @click="handleClick"
        >
            {{ text }}
        </div>
    </div>
</template>

<script>
const { awardButtonStatus } = require('./helpers');
const btnText = {
    notReceivedBtnText: '到店领奖',
    notAvailableBtnText: '暂时无法领取',
    receivedBtnText: '查看奖励'
};
export default {
    props: {
        isLoading: Boolean,
        status: String,
        buttonImage: {
            type: Object,
            default: () => {
                return {
                    notReceivedBtnImg: '',
                    notAvailableBtnImg: '',
                    receivedBtnImg: ''
                };
            }
        }
    },
    computed: {
        btnImage() {
            return this.buttonImage[`${this.status}BtnImg`];
        },
        text() {
            if (this.btnImage) {
                return '';
            }
            return btnText[`${this.status}BtnText`];
        },
        btnStyle() {
            if (this.btnImage) {
                return {
                    background: `center / cover no-repeat url(${this
                        .btnImage})`,
                    borderWidth: '0'
                };
            }
            return { borderWidth: `${100 / 375}vw` };
        },
        disabled() {
            return this.status == awardButtonStatus.REJECTED || this.isLoading;
        }
    },
    methods: {
        async handleClick() {
            if (this.disabled) return;
            this.$emit('action');
        }
    }
};
</script>

<style lang="less" scoped>
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';

.marketing-leads-award-button{
    margin: 0 20 * @layout375 0 20 * @layout375;
    .button {
        cursor: pointer;
        .center();
        height: 45 * @layout375;
        font-size: 16 * @layout375;
        color: #ffffff;
        background: @text_basic_active;
        border-radius: 25 * @layout375;
        border: 1 * @layout375 solid transparent;
        position: relative;
        &.is-disabled,
        &.is-disabled:active {
            color: #ffffff;
            background-color: @background_disable;
            filter: brightness(100%);
            cursor: not-allowed;
        }
        &:active {
            filter: brightness(80%);
            // background: #009292;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/marketing/components/leads-award/award-button.vue